import React, { useEffect, useState } from 'react'
import UbliqueSlider from '@ublique/components/Slider'
import Loading from '@ublique/components/Loading'

import { isEmpty, isUndefined } from 'lodash'
import withDefault from './withDefault'

import '../index.scss'

const SliderWithDefault = ({
  id,
  value,
  setValue,
  invalidText,
  conditionInfo,
  formData,
  creationMode,
  clone,
  defaultValue,
  minValue = 0,
  maxValue = 10000,
  t,
  ...props
}) => {
  const { onBlur, hidden, invalid, label, disabled } = props
  const [loading, setLoading] = useState(false)

  const onChange = (e) => setValue(id, e.value)

  useEffect(() => {
    if (creationMode === 'CLONE_SCENARIO') {
      setValue(id, clone[id] || 0)
    } else {
      if (isEmpty(value) && isUndefined(formData[id])) {
        // SET DEFAULT VALUE
        setLoading(true)
        setValue(id, defaultValue)
        setLoading(false)
      }
    }
  }, [defaultValue, creationMode, clone, id])

  const sliderProps = {
    id,
    onChange,
    onBlur,
    hidden,
    disabled,
    labelText: t(label),
    invalid: invalid || !isEmpty(invalidText),
    min: minValue,
    max: maxValue,
    value,
    invalidText
  }

  if (hidden) {
    return null
  }
  if (loading || isUndefined(value)) {
    return <Loading />
  }
  return (
    <div className='scenario-slider'>
      <UbliqueSlider {...sliderProps} inputType='number' />

      {sliderProps.invalid && (
        <span className='invalid-text'>{invalidText}</span>
      )}
    </div>
  )
}

export default withDefault(SliderWithDefault)
